import React from 'react';
import {Button} from 'antd';

const launchView = (type, id, url) => {
  if(type === "Bar Chart"){
      window.open(url+"/pylo/barchart.php?sess_id="+id);
  }else if (type === "Tree Chart"){
      window.open(url+"/pylo/treechart.php?sess_id="+id);
  }else if (type === "Pie Chart"){
      window.open(url+"/pylo/piechart.php?sess_id="+id);
  }
}

const ResultListViewButtons = (props) => {
  const {types, id, url} = props.text;
  return(
    <div>
    {
      types.length > 0
      &&
      types.map((value, index)=>{
        return(
          <span key={index}>
            <Button type="primary"
              icon="select"
              onClick={()=>launchView(value, id, url)}>{value}</Button>
            <span style={{width: 30, marginLeft: 10}}></span>
          </span>
        )
      })
    }
    {
      types.length === 0
      &&
      <Button disabled>not available</Button>
    }
    </div>
  );
}

export default ResultListViewButtons;